// extracted by mini-css-extract-plugin
export var bio = "fc-team-module--bio--e54bd";
export var col = "fc-team-module--col--00d44";
export var content = "fc-team-module--content--29829";
export var contentWrap = "fc-team-module--contentWrap--41f4e";
export var grid = "fc-team-module--grid--d9853";
export var image = "fc-team-module--image--070e4";
export var link = "fc-team-module--link--9c376";
export var name = "fc-team-module--name--a5635";
export var position = "fc-team-module--position--1a154";
export var readBio = "fc-team-module--readBio--49f3e";
export var root = "fc-team-module--root--63477";
export var text = "fc-team-module--text--9d21f";
export var title = "fc-team-module--title--a0ef4";